import React from "react";

// Official-style Apple logo mark.
const AppleLogo = ({ className = "" }) => (
  <svg viewBox="0 0 384 512" fill="currentColor" className={className} aria-hidden="true">
    <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zM262.1 104.5c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
  </svg>
);

// Google Play mark (four-colour triangle).
const GooglePlayLogo = ({ className = "" }) => (
  <svg viewBox="0 0 512 512" className={className} aria-hidden="true">
    <path fill="#00C3FF" d="M47 24.9C38 29.6 32.6 38.9 32.6 51v410c0 12.1 5.4 21.4 14.4 26.1l238.2-231.1z" />
    <path fill="#00E676" d="M47 24.9 285.2 256l64.6-62.7L96.8 7.7C83 .1 66 .6 47 24.9z" />
    <path fill="#FFCE00" d="M349.8 193.3 285.2 256l64.6 62.7 78.9-43.1c18.6-10.1 18.6-39.1 0-49.2z" />
    <path fill="#FF3D47" d="M47 487.1c12 6.2 27.8 5.3 49.8-6.9l253-138-64.6-62.6z" />
  </svg>
);

const badge =
  "inline-flex items-center justify-center h-14 w-14 rounded-none border-2 border-[color:var(--coh-ink)] bg-[color:var(--coh-blue)] text-[color:var(--coh-on-accent)] shadow-nb cursor-not-allowed select-none";

/**
 * App Store + Google Play "download" marks.
 * The app is not live yet, so these are COMING SOON placeholders: compact,
 * icon-only, non-clickable badges (no store links, no email capture).
 */
export const StoreButtons = ({ className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <span
        role="img"
        data-testid="app-store-button"
        aria-label="App Store — coming soon"
        title="App Store — coming soon"
        className={badge}
      >
        <AppleLogo className="h-7 w-7 shrink-0" />
      </span>
      <span
        role="img"
        data-testid="google-play-button"
        aria-label="Google Play — coming soon"
        title="Google Play — coming soon"
        className={badge}
      >
        <GooglePlayLogo className="h-6 w-6 shrink-0" />
      </span>
    </div>
  );
};
